export default __webpack_public_path__ + "static/media/dos.1d407be0.mp3";